import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { SCOUT_TEAL } from '../../../ThemeContext/constants';

import type { CircularProgressProps } from '@mui/material/CircularProgress';

const CircularProgressWithLabel = (
  props: CircularProgressProps & { value: number; size?: number }
) => (
  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
    <CircularProgress
      size={props.size ? props.size : 120}
      thickness={6}
      variant="determinate"
      sx={{
        color: SCOUT_TEAL,
        circle: {
          strokeLinecap: 'round'
        }
      }}
      {...props}
    />
    <Box
      sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontFamily: 'Source Sans Pro',
        fontWeight: 'bold'
      }}
    >
      {Math.round(props.value)}
    </Box>
  </Box>
);

export default CircularProgressWithLabel;

export const CircularStatic = () => {
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return <CircularProgressWithLabel value={progress} />;
};
